// import { app } from '../../messaging_init_in_sw'
import React, {
  useCallback,
  useEffect,
  useState,
  useContext,
  useRef,
  Suspense,
} from "react";
import { AutoComplete } from "primereact/autocomplete";
import { getTrans as T } from "../Language";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import ComponentLoader from "./ComponentLoader";
import { getEmployeeList } from "../../Component/Home/EmployeeList/Service/employeeService";
import {
  NotificationCount,
  uploadDoc,
} from "../../Services/Global-Services/GlobalServices";
import { performLogoutNoRedirect } from "../../Services/Global-Services/AuthLogoutHandler";
import { TostMsg } from "../../App";
import $ from "jquery";
import { useDispatch } from "react-redux";
import {
  setCreatePostRequestData,
  setFeedRequestData,
  setLeaveRequestData,
  setSearchRequestData,
} from "../../Services/Redux/DataTransferToAnother";
import { postFeed } from "../../Component/Home/Dashboard/Services/DashboardServices";
import ERROR_LIST from "../../Services/Global-Services/Hadle_Errors";
import { LazyVideo } from "../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { Mention } from "primereact/mention";
import { Carousel } from "primereact/carousel";
import EmojiPicker from "emoji-picker-react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";
import UploadFile_KEYS from "../../Services/Global-Services/UploadFile_Keys";
import LoginLoader from "./LoginLoader";
import { getRawPermissionsArray, getRawSystemAlertsArray } from "../../Routes/AuthGard/usePermissions";
import ImageCropperModalMulti from "../../Services/Comment/ImageCropperModalMulti";
import ChatInput from "../../Component/Home/ChatBot1/ChatInput";

const defaultImage = "/images/placeholder_profile.png";

// let MenueIconList = JSON.parse(localStorage.getItem("DynamicMenuJson") || "{}");
const SharedSidebar = () => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let userPermissions = getRawPermissionsArray();
  let SystemAlerts = getRawSystemAlertsArray();
  let AppVersion = JSON.parse(localStorage.getItem("AppVersion") || "{}");
  let NotificationCounts = JSON.parse(
    localStorage.getItem("NotificationCount") || "0",
  );
  const [selectedObservers, setSelectedObservers] = useState(null);
  const [filteredObservers, setFilteredObservers] = useState(null);
  const [allUserDetails, setAllUserDetails] = useState([]);
  const [logoutContent, setLogoutContent] = useState("");
  const [Isloading, setIsloading] = useState(false);
  const [IsMenuloading, setIsMenuloading] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [orgInfoMes, setOrgInfoMes] = useState("");
  const [orgPowered, setPoweredBy] = useState("");
  const [orgPoweredUrl, setPoweredByUrl] = useState("");
  const [orggenie_Error_Network, setOrggenie_Error_Network] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [mySetting, setIsMySetting] = useState(false);
  const [reportRead, setReportRead] = useState(false);
  const toster = useContext(TostMsg);
  const [ImagePath, setImagePath] = useState([]);
  const [mentionedArr, setMentionedArr] = useState([]);
  const [multipleSuggestions, setMultipleSuggestions] = useState([]);
  const [feedText, setFeedText] = useState("");
  const [file, setFile] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [isVisibleEmoji, setisVisibleEmoji] = useState(false);
  const [MenueIconList, setMenuIconList] = useState({});
  const [poweredBy_Header, setPoweredBy_Header] = useState("");
  const [showCropper, setShowCropper] = useState(false);
  const [fileSizeError, setFileSizeError] = useState("");
  const videoFilesRef = useRef([]);
  const storedMenu = JSON.parse(
    localStorage.getItem("DynamicMenuJson") || "{}",
  );

  const NotificationCountRequest = useSelector(
    (state) => state.notificationCounts.notificationRequestData,
  );

  const [multiImageSrcs, setMultiImageSrcs] = useState([]); // for multiple
  const [imageSrc, setImageSrc] = useState(null); // for single image
  const [acceptRatio, setAcceptRatio] = useState(1 / 1);
  const [notificationsList, setNotificationsList] = useState(0);
  const [isVisibleAutocomplete, setIsVisibleAutocomplete] = useState(true);
  const [exitStatus, setExitStatus] = useState(false);
  const [documentRead, setDocumentRead] = useState(false);
  const [feedPost, setFeedPost] = useState(false);
  const [projectManage, setProjectManage] = useState(false);
  const tagSuggestions = [
    "instagood",
    "photooftheday",
    "beautiful",
    "art",
    "photography",
    "happy",
    "picoftheday",
    "cute",
    "follow",
    "followme",
    "nature",
    "like4like",
    "travel",
    "instagram",
    "style",
    "repost",
    "summer",
    "instadaily",
    "selfie",
    "me",
    "friends",
    "fitness",
    "girl",
    "food",
    "fun",
    "beauty",
    "instalike",
    "smile",
    "family",
    "photo",
    "life",
    "likeforlike",
    "music",
    "ootd",
    "follow4follow",
    "makeup",
    "amazing",
    "igers",
    "nofilter",
    "dog",
    "model",
    "sunset",
    "beach",
  ];
  const history = useHistory();
  const [isVisible, setIsVisible] = useState(false);



  useEffect(() => {
    GetMasterSystemAlertList();
  }, []);

  useEffect(() => {
    setNotificationsList(NotificationCounts);
    setMenuIconList(storedMenu);

    if (storedMenu?.EmployeeFunctionalityGroups?.length > 0) {
      setIsMenuloading(false);
    } else {
      setIsMenuloading(true);
    }
    // notificationCount();
    if (feedText) {
      setIsVisible(true);
    } else if (ImagePath?.length) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [feedText, ImagePath]);

  useEffect(() => {
    if (NotificationCountRequest == "hitNotification") {
      notificationCount();
    }
  }, [NotificationCountRequest, notificationsList]);

  // For get notification count.
  async function notificationCount() {
    var params = {
      EmpId: userDetails?.EmpId,
    };
    try {
      const data = await NotificationCount(params);
      let notificationsCount = data?.Data[0]?.UnreadNotifications;
      setNotificationsList(notificationsCount);
      localStorage.setItem(
        "NotificationCount",
        JSON.stringify(notificationsCount),
      );
    } catch (error) {
      toster.current.error(ERROR_LIST?.NotificationError);
    }
  }

  useEffect(() => {
    setTimeout(() => {
      if (SystemAlerts?.length > 0) {
        GetMasterSystemAlertList("Orggenie_OrgInfo_message", 2);
        GetMasterSystemAlertList("logout_Message", 3);
        GetMasterSystemAlertList("PoweredBy_Header", 4);
        GetMasterSystemAlertList("PoweredBy_Text", 5);
        GetMasterSystemAlertList("PoweredBy_Link", 6);
        GetMasterSystemAlertList("Orggenie_Error_Network", 7);
      }
    }, 2000);
  }, [SystemAlerts]);

  useEffect(() => {
    permissionAccouncementList();

    const updateNetworkStatus = () => {
      if (navigator.onLine) {
        window.location.reload();
      } else {
        setIsOnline(navigator.onLine);
        $("body").addClass("overflow-y-hidden");
      }
    };
    window.addEventListener("online", updateNetworkStatus);
    window.addEventListener("offline", updateNetworkStatus);
    return () => {
      window.removeEventListener("online", updateNetworkStatus);
      window.removeEventListener("offline", updateNetworkStatus);
    };
  }, []);

  const permissionAccouncementList = () => {
    userPermissions?.map((UserPermission) => {
      if (UserPermission.PermissionName == "Account.Update") {
        setIsAuthenticated(true);
      } else if (UserPermission.PermissionName == "My_Setting") {
        setIsMySetting(true);
      } else if (UserPermission.PermissionName == "Reports.Read") {
        setReportRead(true);
      }
      if (UserPermission.PermissionName == "exit.manage") {
        setExitStatus(true);
      }

      if (UserPermission.PermissionName == "Document.Read") {
        setDocumentRead(true);
      }

      if (UserPermission?.PermissionName == "Employee.Read") {
        setEmployeeRead(true);
      }

      if (UserPermission.PermissionName == "Leave.Read") {
        setLeaveRead(true);
      }
      if (UserPermission.PermissionName == "Feed.Post") {
        setFeedPost(true);
      }
      // if (UserPermission.PermissionName == "Project.Manage") {
      //   setProjectManage(true);
      // }
      if (UserPermission.PermissionName == "Task.Read") {
        setProjectManage(true);
      }
    });
  };

  const panelFooterTemplate = () => {
    const isObserversSelected = (filteredObservers || []).some(
      (country) => country["FullName"] === selectedObservers,
    );
    return (
      <div className="py-2 px-3">
        {isObserversSelected && (
          <span>
            <b>{selectedObservers}</b> selected.
          </span>
        )}
      </div>
    );
  };


  function openSearch() {
    setIsVisibleAutocomplete(true);
    // fetchEmployeeIdData();
    document.getElementById("searchmyNav").style.display = "block";
    document.body.style.overflow = "hidden";
  }

  function closeSearch() {
    document.getElementById("searchmyNav").style.display = "none";
    document.body.style.overflow = "visible";
  }

  function openNav() {
    document.getElementById("mySidepanel").style.marginLeft = "33.9%";
    document.getElementById("overlay").style.display = "block";
  }

  function closeNav() {
    document.getElementById("mySidepanel").style.marginLeft = "-100%";
    let overlay = document.getElementById("overlay");
    if (overlay) {
      overlay.style.display = "none";
    }
    document.body.style.overflow = "visible";
  }

  const itemTemplateObservers = (item) => {
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <img
          alt={item.FullName}
          src={item.ProfileImage || defaultImage}
          width="32"
          onError={handleImageError}
        />
        <span>
          {item.FullName} ({item.EmploymentId}) ({item.UserName})
        </span>
      </div>
    );
  };

  const search = (event) => {
    setTimeout(() => {
      let _filteredObervers;

      if (!event.query.trim().length) {
        _filteredObervers = [...allUserDetails];
      } else {
        _filteredObervers = allUserDetails.filter((item) => {
          return item.FullName.toLowerCase().startsWith(
            event.query.toLowerCase(),
          );
        });
      }

      setFilteredObservers(_filteredObervers);
    }, 250);
  };

  //For get the employee data.
  async function fetchEmployeeIdData(event) {
    setLoader(true);
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: event.query,
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 1000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    try {
      let employeesList = await getEmployeeList(params);
      setFilteredObservers(employeesList?.Data);
      setLoader(false);
    } catch (error) {
      toster.current.error(ERROR_LIST.EmployeeListDataError);
      setLoader(false);
    }
  }

  // function userDetailsPage() {
  //   if (selectedObservers?.EmpId) {
  //     history.push(`/Profile/${selectedObservers.GUID}`);
  //   } else {
  //     const index = filteredObservers.findIndex(o => o.EmpId === selectedObservers?.EmpId);
  //     if (index !== -1) {
  //       const [matchedObserver] = filteredObservers.splice(index, 1);
  //       filteredObservers.unshift(matchedObserver);
  //     }
  //     dispatch(setLeaveRequestData(filteredObservers));
  //     history.push(`/SearchResult`);
  //   }
  //   closeSearch();
  // }

  function userDetailsPage() {
    if (selectedObservers?.EmpId) {
      history.push(`/Profile/${selectedObservers.GUID}`);
    } else {
      dispatch(setSearchRequestData(selectedObservers));
      setFilteredObservers([]);
      history.push(`/SearchResult`);
    }
    setIsVisibleAutocomplete(false);
    closeSearch();
  }
  const redirectToAnotherPage = (item) => {
    if (item?.Code == "CO-001") {
      history.push(`/TeamDirectory`);
    } else if (item?.Code == "CO-002") {
      history.push(`/Announcement`);
    } else if (item?.Code == "CO-003") {
      history.push(`/Messages`);
    } else if (item?.Code == "CO-004") {
      history.push(`/Dashboard`);
    } else if (item?.Code == "CO-005") {
      history.push(`/Articles`);
    } else if (item?.Code == "OG-002") {
      history.push(`/Feed/Popular`);
    } else if (item?.Code == "OG-003") {
      history.push(`/Feed/Featured`);
    } else if (item?.Code == "OG-004") {
      window?.$("#check-feedpost")?.modal("show");
      fetchData();
      closeNav();
      // document.getElementById("mySidepanel").style.marginLeft = "-100%";
      // document.getElementById("overlay").style.display = "none";
    } else if (item?.Code == "OG-005") {
      history.push(`/Feed/User/${userDetails?.GUID}`);
    } else if (item?.Code == "OG-007") {
      history.push(`/Policylist`);
    } else if (item?.Code == "OG-008") {
      history.push(`/OrgnizationTeam`);
    } else if (item?.Code == "LV-001") {
      history.push(`/LeaveDashboard`);
    } else if (item?.Code == "LV-002") {
      history.push(`/Leave`);
    } else if (item?.Code == "LV-003") {
      history.push(`/OrganizationLeave`);
    } else if (item?.Code == "LV-004") {
      history.push(`/MyLedger`);
    } else if (item?.Code == "LV-005") {
      history.push(`/TeamLeave`);
    } else if (item?.Code == "LV-006") {
      history.push(`/ApplyForOther`);
    } else if (item?.Code == "LV-007") {
      history.push(`/LeaveAdjustment`);
    } else if (item?.Code == "LV-008") {
      history.push(`/Calendar`);
    } else if (item?.Code == "LV-009") {
      history.push(`/LeaveDashboard`);
    } else if (item?.Code == "WH-001") {
      history.push(`/WfhDashboard`);
    } else if (item?.Code == "WH-007") {
      history.push(`/WfhDashboard`);
    } else if (item?.Code == "WH-002") {
      history.push(`/MyWfh`);
    } else if (item?.Code == "WH-003") {
      history.push(`/TeamWfh`);
    } else if (item?.Code == "WH-004") {
      history.push(`/ledger`);
    } else if (item?.Code == "WH-005") {
      history.push(`/WfhApplyForOther`);
    } else if (item?.Code == "WH-006") {
      history.push(`/WFHAdjustment`);
    } else if (item?.Code == "WH-007") {
      history.push(`/Dashboard`);
    } else if (item?.Code == "HD-001") {
      history.push(`/AddTicket`);
    } else if (item?.Code == "HD-002") {
      history.push(`/MyTickets`);
    } else if (item?.Code == "HD-003") {
      history.push(`/Ticket`);
    } else if (item?.Code == "C-001") {
      history.push(`/Awards`);
    } else if (item?.Code == "C-002") {
      history.push(`/Celebrations`);
    } else if (item?.Code == "C-003") {
      history.push(`/Gallery`);
    } else if (item?.Code == "C-004") {
      history.push(`/RaiseaFlag`);
    } else if (item?.Code == "C-005") {
      history.push(`/Exit`);
    } else if (item?.Code == "P-001") {
      history.push(`/Profile/${userDetails?.GUID}`);
    } else if (item?.Code == "P-002") {
      history.push(`/Followers/${userDetails?.GUID}`);
    } else if (item?.Code == "P-003") {
      history.push(`/Followings/${userDetails?.GUID}`);
    } else if (item?.Code == "P-004") {
      history.push(`/Dashboard`);
    } else if (item?.Code == "P-005") {
      history.push(`/ChangePassword`);
    } else if (item?.Code == "P-007") {
      history.push(`/AssessmentCycles`);
    } else if (item?.Code == "P-006") {
      history.push(`/Assessment/Employee/Cycles`);
    } else if (item?.Code == "G-001") {
      history.push(`/SendUsFeedback`);
    } else if (item?.Code == "OG-009") {
      history.push(`/Assets/List`);
    } else if (item?.Code == "G-002") {
      history.push(`/SuggestAfeature`);
    } else if (item?.Code == "G-003") {
      history.push(`/Preferences`);
    } else if (item?.Code == "G-004") {
      history.push(`/About`);
    } else if (item?.Code == "G-005") {
      window.open("/Legal", "_blank");
    } else if (item?.Code == "G-006") {
      history.push(`/Version`);
    } else if (item?.Code == "G-007") {
      window?.$("#logout-popup")?.modal("show");
    } else if (item?.Code == "PR-004" && documentRead) {
      history.push(`/Documents`);
    } else if (item?.Code == "OG-006") {
      history.push(`/Survey/List`);
    } else if (item?.Code == "PR-001") {
      history.push(`/Timesheet/Summary`);
    } else if (item?.Code == "PR-002") {
      history.push(`/Timesheet/Entry`);
    }
    // else if (item?.Code == "PR-002") {
    //   history.push(`/Timesheet/Entry`);
    // }
    else if (item?.Code == "PR-003") {
      history.push(`/Timesheet/Approval`);
    } else if (item?.Code == "R-001") {
      history.push(`/RecruitmentDashboard`);
    } else if (item?.Code == "R-002") {
      history.push(`/Positions`);
    } else if (item?.Code == "R-003") {
      history.push(`/ApplicantSearch`);
    } else if (item?.Code == "R-004") {
      history.push(`/AddApplicant`);
    } else if (item?.Code == "R-005") {
      history.push(`/CreatePosition`);
    } else if (item?.Code == "AP-007") {
      history.push(`/Geotag-Employee_Popup`);
    } else if (item?.Code == "AP-006") {
      history.push(`/Geotag-Locations`);
    } else if (item?.Code == "AP-005") {
      history.push(`/Geotag-Employee-Assignment`);
    } else if (item?.Code == "AP-004") {
      history.push(`/Attendance-Security`);
    } else if (item?.Code == "AP-003") {
      history.push(`/Attendance-Register`);
    } else if (item?.Code == "AP-002") {
      history.push(`/My-Attendance`);
    } else if (item?.Code == "AP-009") {
      history.push(`/Payroll/Dashboard`);
    } else if (item?.Code == "AP-008") {
      history.push(`/Attendance-Regularization`);
    } else if (item?.Code == "PR-005") {
      history.push(`/Project/Dashboard`);
    } 
    else if(item?.Code == "PR-006") {
      history.push(`/Assessment/Cycles`);
    }
    else if (item?.Code == "PR-007") {
      history.push(`/Assessment/Employee/Dashboard`)
    }
    
    
    else {
      history.push(`/Unauthorized`);
    }
    closeNav();
  };

  const handleLogout = () => {
    GetMasterSystemAlertList("SignOut_message", 0);
    document.querySelector("#logout-popup .cancelbtn-click")?.click();
    performLogoutNoRedirect();
    setIsloading(false);
    // Redirect to login after cleanup
    setTimeout(() => {
      history.push("/");
    }, 100);
  };



  const GetMasterSystemAlertList = useCallback(
    (message, type) => {
      if (!SystemAlerts) return;

      SystemAlerts?.forEach((msg) => {
        if (msg?.Name == message && type === 0) {
          if (toster.current) {
            toster.current.success(msg?.Desc);
          }
        } else if (msg?.Name == message && type == 2) {
          setOrgInfoMes(msg?.Desc);
        } else if (msg?.Name == message && type == 3) {
          setLogoutContent(msg?.Desc);
        } else if (msg?.Name == message && type == 4) {
          setPoweredBy_Header(msg?.Desc);
        } else if (msg?.Name == message && type == 5) {
          setPoweredBy(msg?.Desc);
        } else if (msg?.Name == message && type == 6) {
          setPoweredByUrl(msg?.Desc);
        } else if (msg?.Name == message && type == 7) {
          setOrggenie_Error_Network(msg?.Desc);
        }
      });
    },
    [
      orgInfoMes,
      logoutContent,
      poweredBy_Header,
      orgPowered,
      orgPoweredUrl,
      orggenie_Error_Network,
    ],
  );

  const [employeeRead, setEmployeeRead] = useState(false);
  const [leaveRead, setLeaveRead] = useState(false);
  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (!event.target.closest(".mobileviewhide")) {
      if (!event.target.closest(".close-tab")) {
        closeNav();
      }
    }
  };

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const fetchData = async () => {
    await fetchEmployeeData();
  };

  const PostFeed = useCallback(async () => {
    setIsloading(true);
    if (mentionedArr != undefined) {
      const body = {
        Id: 0,
        EmpId: userDetails?.EmpId,
        FeedText: feedText,
        IsCommentEnabled: true,
        IsLikeCountVisible: true,
        CommentVisible: true,
        IsLikeEnabled: true,
        PostMedia: ImagePath,
        PostMentions: mentionedArr,
      };
      try {
        let res = await postFeed(body);
        document.querySelector("#check-feedpost .btn-close")?.click();
        toster.current.success("Feed post successfully.");
        setImagePath((image) => (image, []));
        setMentionedArr((mention) => (mention, []));
        // setSelectedFeedText(FeedText => (FeedText, []));
        dispatch(setCreatePostRequestData(res));
        setFeedText("");
        history?.push("/Dashboard");
        setIsloading(false);
      } catch (error) {
        setIsloading(false);
        toster.current.error(ERROR_LIST?.DashboardFeaturePost);
      }
    } else {
      setIsloading(false);
      toster.current.error("Please mention again.");
    }
  }, [mentionedArr, ImagePath, feedText]);

  const ResetFeedFields = () => {
    setFileSizeError("");
    setImagePath((image) => (image, []));
    setMentionedArr((mention) => (mention, []));
    // setSelectedFeedText(FeedText => (FeedText, []));
    setFeedText("");
    $(".input-Btn")?.hide("slow");
  };
  const getFeedText = useCallback((event) => {
    setFeedText(event.target.value);
  }, []);

  let EmojiArr = [];
  const onEmojiClick = (emojiObject) => {
    let textId = document.getElementById("feedareatexts");
    const start = textId.selectionStart;
    const end = textId.selectionEnd;
    EmojiArr.push(...emojiObject.emoji);
    const netText =
      textId.value.slice(0, start) + EmojiArr[0] + textId.value.slice(start);
    textId.value = netText;
    const newCursorPosition = start + EmojiArr[0].length;
    textId.setSelectionRange(newCursorPosition, newCursorPosition);
    textId.focus();
    setFeedText(netText);
  };

  // useEffect(() => {}, [ImagePath]);

  async function fetchEmployeeData() {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    try {
      let employeesList = await getEmployeeList(params);
      setEmployee(employeesList.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }

  const responsiveOptions = [
    {
      breakpoint: "1400px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "1199px",
      numVisible: 3,
      numScroll: 1,
    },
    {
      breakpoint: "767px",
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: "575px",
      numVisible: 1,
      numScroll: 1,
    },
  ];

  // For HTML Content
  function showPopup() {
    if (ImagePath.length == 0) {
      $(".upload-img")?.show("slow");
      $(".input-Btn")?.hide("slow");
    } else {
      $(".input-Btn")?.show("slow");
      $(".upload-img")?.hide("slow");
    }
  }
  function hidePopup() {
    $(".input-Btn")?.hide("slow");
    $(".upload-img")?.hide("slow");
  }

  const [posterSrc, setPosterSrc] = useState("");
  useEffect(() => {
    const video = document.getElementById("videoElement");
    if (video) {
      video.addEventListener("loadeddata", () => {
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const poster = canvas.toDataURL("image/jpeg");
        setPosterSrc(poster);
      });
    }
  }, []);

  const UploadedMediaTemplate = (media, index) => {
    return (
      <div className="border-1 surface-border border-round m-2 text-center">
        <div className="mb-3">
          {media?.MediaPath?.endsWith(".mp4") ||
            media?.MediaPath?.toLowerCase()?.endsWith(".mov") ? (
            <div key={index} className="videoContainer">
              <a onClick={() => DeleteUploadedImage(index)}>x</a>
              {/* <a key={index} onClick={() => DeleteUploadedImage(index)}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-x-square-fill Hide-upload-div" viewBox="0 0 16 16"><path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm3.354 4.646L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708"></path></svg>
                          </a> */}
              <LazyVideo
                id="videoElement"
                src={`${media?.MediaPath}`}
                poster={posterSrc}
                playsInline
                muted
                controls
              />
            </div>
          ) : (
            <div key={index} className="uploaded-imgtrash">
              <a onClick={() => DeleteUploadedImage(index)}>x</a>
              {/* <a key={index} onClick={() => DeleteUploadedImage(index)}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-x-square-fill Hide-upload-div" viewBox="0 0 16 16"><path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm3.354 4.646L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708"></path></svg>
                          </a> */}
              <img
                src={`${media?.MediaPath || defaultImage}`}
                onError={handleImageError}
                alt="Description of the image"
              />
            </div>
          )}
        </div>
      </div>
    );
  };

  const DeleteUploadedImage = (index) => {
    const newCardList = [...ImagePath];
    newCardList.splice(index, 1);
    setImagePath(newCardList);
    if (ImagePath.length == 1) {
      $(".upload-img").show("slow");
      $(".input-Btn").hide("slow");
    } else {
      $(".input-Btn").show("slow");
      $(".upload-img").hide("slow");
    }
  };

  const multipleItemTemplate = (suggestion, options) => {
    const trigger = options.trigger;
    if (trigger === "@" && suggestion.FullName) {
      return itemTemplate(suggestion);
    } else if (trigger === "#" && !suggestion.FullName) {
      return <span>{suggestion}</span>;
    }
    return null;
  };

  const onSelectHandler = useCallback(
    (e) => {
      let selectedMention = {
        MentionedName: e.suggestion?.FullName,
        MentionedId: e.suggestion?.Id,
        CommentId: 0,
      };
      setMentionedArr((prevSelectedData) => [
        ...prevSelectedData,
        selectedMention,
      ]);
    },
    [mentionedArr],
  );
  // const onSelectHandler = useCallback((e) => {
  //   const selectedMention = e.suggestion;
  //   // setSelectedFeedText([
  //   //     selectedMention,
  //   // ]);
  //   setSelectedFeedText((prevSelectedData) => [
  //     ...prevSelectedData,
  //     selectedMention,
  //   ]);
  // }, [selectedFeedText]);

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  // Input tigger form img tag in Inner HTML
  const fileImageInputRef = useRef(null);
  function openSelectImageInput() {
    fileImageInputRef.current.click();
  }

  //Input tigger form p tag in Inner HTML
  const fileInputRef = useRef(null);
  function openFileInput() {
    fileInputRef.current?.click();
  }

  // Upload your feed image and video data
  // const handleFileImageChange = useCallback(async (event) => {
  //   const selectedFile = await event.target.files;
  //   setFile(selectedFile);
  // }, []);

  const handleFileImageChange = async (event) => {
    const files = Array.from(event.target.files);
    const MAX_FILE_SIZE = 20 * 1024 * 1024;
    const oversizedFiles = files.filter((file) => file.size > MAX_FILE_SIZE);
    if (!files.length) return;

    if (oversizedFiles.length <= 0) {
      setFileSizeError("");
      const imageFiles = files.filter((file) => file.type.startsWith("image/"));
      const videoFiles = files.filter((file) => file.type.startsWith("video/"));

      videoFilesRef.current = videoFiles;
      if (imageFiles.length > 0) {
        try {
          const imageDataURLs = await Promise.all(
            imageFiles.map((file) => {
              return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
              });
            }),
          );

          if (imageDataURLs.length > 0) {
            setImageSrc(null);
            setMultiImageSrcs(imageDataURLs);
            setAcceptRatio(1 / 0.6);
            setShowCropper(true);
          }
        } catch (err) {
          console.error("Failed to read image files", err);
        }
      } else if (videoFiles.length > 0) {
        // ✅ If only video files, set them immediately
        setFile(videoFiles);
        videoFilesRef.current = []; // Clear to prevent re-adding later
      }

      fileInputRef.current.value = "";
    } else {
      setFileSizeError("File too large. Maximum size: 20 MB.");
    }
  };

  const handleCropComplete = (croppedData) => {
    const blobs = Array.isArray(croppedData) ? croppedData : [croppedData];
    const croppedFiles = blobs.map(
      (blob, index) =>
        new File([blob], `cropped-${index + 1}.jpg`, { type: "image/jpeg" }),
    );
    const finalFiles = [...croppedFiles, ...videoFilesRef.current];
    setFile(finalFiles);
    videoFilesRef.current = [];
  };

  useEffect(() => {
    if (file?.length > 0) {
      uploadMediaFile();
    }
  }, [file]);

  async function uploadMediaFile() {
    setIsloading(true);
    if (file && file.length > 0) {
      const formData = new FormData();
      for (let i = 0; i < file.length; i++) {
        formData.append("files", file[i]);
      }
      let params = {
        UploadType: UploadFile_KEYS?.Feed,
        RefId: 0,
      };
      try {
        const response = await uploadDoc(params, formData);
        const data = await response;
        const ImageURL = data?.Data;
        $(".upload-img").hide("slow");
        $(".input-Btn").show("slow");
        if (ImageURL && ImageURL.length > 0) {
          const processedMedia = [];
          for (let i = 0; i < ImageURL.length; i++) {
            const media = ImageURL[i];
            const currentFile = file[i];
            if (media.slice(-3) === "mp4" || media.slice(-3) === "mov") {
              const duration = await getVideoDuration(media);
              processedMedia.push({
                MediaPath: media,
                MediaName: "",

                // MediaPath: media,
                // MediaSize: currentFile.size,
                // MediaDuration: duration,
                // MediaType: currentFile.type,
              });
              setIsloading(false);
            } else {
              processedMedia.push({
                MediaPath: media,
                MediaName: String(currentFile.type),
                // MediaPath: media,
                // MediaSize: currentFile.size,
                // MediaDuration: 0,
                // MediaType: currentFile.type,
              });
              setIsloading(false);
            }
          }
          setImagePath((prev) => [...prev, ...processedMedia]);
          // setImagePath((prev) => [...prev, ...processedMedia]);
        }
      } catch (error) {
        setIsloading(false);
        toster.current.error(ERROR_LIST.UploadFileError);
      } finally {
        setIsloading(false);
      }
    } else {
      setIsloading(false);
      toster.current.warn("No file selected.");
    }
  }

  // Helper function to get video duration
  function getVideoDuration(mediaPath) {
    return new Promise((resolve) => {
      const videoElement = document.createElement("video");
      videoElement.src = mediaPath;
      videoElement?.addEventListener("loadedmetadata", () => {
        resolve(videoElement.duration);
      });
    });
  }

  const onMultipleSearch = (event) => {
    const trigger = event.trigger;
    if (trigger === "@") {
      setTimeout(() => {
        const query = event.query;
        let suggestions;
        if (!query.trim().length) {
          suggestions = [...employee];
        } else {
          suggestions = employee.filter((customer) => {
            return customer.FullName.toLowerCase().startsWith(
              query.toLowerCase(),
            );
          });
        }
        setMultipleSuggestions(suggestions);
      }, 250);
    } else if (trigger === "#") {
      setTimeout(() => {
        const query = event.trigger;
        let suggestions;

        if (!query.trim().length) {
          suggestions = [...tagSuggestions];
        } else {
          suggestions = tagSuggestions.filter((tag) => {
            return tag.toLowerCase();
            // return tag.toLowerCase().startsWith(query.toLowerCase());
          });
        }
        setMultipleSuggestions(suggestions);
      }, 250);
    }
  };

  const itemTemplate = (suggestion) => {
    const src = suggestion.ProfileImage;
    return (
      <div className="flex align-items-center">
        <img
          alt={suggestion.FullName || defaultImage}
          onError={handleImageError}
          src={src}
          th="32"
          style={{ maxWidth: "10%", height: "auto" }}
        />
        <span className="flex flex-column ml-2">
          {suggestion.FullName}
          {/* <small style={{ fontSize: '.75rem', color: 'var(--text-color-secondary)' }}>@{suggestion.FullName}</small> */}
        </span>
      </div>
    );
  };

  //Drag and Drop Media function
  const handleDrop = (event) => {
    event.preventDefault();
    const files = event?.dataTransfer?.files;
    if (files.length) {
      setFile(files);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (selectedObservers?.EmpId) {
        history.push(`/Profile/${selectedObservers.GUID}`);
      } else {
        userDetailsPage();
      }
    }
  };

  const orgLogo = userDetails?.Organization?.OrgLogo;
  const fallbackLogo = "/images/icon2.png";
  const [currentLogo, setCurrentLogo] = useState(orgLogo);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentLogo((prevLogo) =>
        prevLogo === orgLogo ? fallbackLogo : orgLogo,
      );
    }, 1500);

    return () => clearInterval(interval);
  }, [orgLogo, fallbackLogo]);
  return (
    <>
      <div className="nav-header">
        {/* <div className="bg-block brand-logo active">
          <img src="/images/icon.png" className="logo-abbr" />
        </div>
        <div className="bg-block brand-logo">
          <img src="/images/icon2.png" className="logo-abbr" />
        </div> */}
        <Link to={"/Dashboard"}>
          <div className="bg-block brand-logo active">
            <img
              src={currentLogo || defaultImage}
              onError={handleImageError}
              className="logo-abbr"
              to={"/Dashboard"}
              alt="Logo"
            />
          </div>
        </Link>
        <div className="nav-control">
          <div className="hamburger">
            <span className="line"></span>
            <span className="line"></span>
            <span className="line"></span>
          </div>
        </div>
      </div>

      <div className="deznav">
        <div className="deznav-scroll">
          <ul className="metismenu" id="menu">
            <li>
              <Link
                to={"/Dashboard"}
                className="has-arrow ai-icon"
                // aria-expanded="false"
                data-bs-toggle="tooltip"
                data-placement="right"
                title="Dashboard"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <img src="/images/menu-icon/dashboard.svg" />
              </Link>
            </li>

            {MenueIconList?.EmployeeFunctionalityGroups?.map((category) =>
              category?.EmployeeFunctionalityList
                ?.filter((menu) => menu?.IsAppearOnWebSideBar === 1)
                .map((menu) => {
                  return (
                    <li key={menu?.Id}>
                      <a
                        className="has-arrow ai-icon"
                        aria-expanded="false"
                        data-bs-toggle="tooltip"
                        data-placement="right"  
                        title={menu?.FeatureName}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          redirectToAnotherPage(menu);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <img src={menu?.SecondIconPath} alt={menu?.FeatureName} />
                      </a>
                    </li>
                  );
                })
            )}

            {/* More menu — always shown */}
            <li className="mobileviewhide">
              <a
                className="has-arrow ai-icon"
                aria-expanded="false"
                data-bs-toggle="tooltip"
                data-placement="right"
                onClick={openNav}
                title="More"
              >
                <img src="/images/menu-icon/more.svg" />
              </a>
            </li>

            <div id="mySidepanel" className="sidepanel">
              {IsMenuloading ? <ComponentLoader /> : ""}
              <div className="quick-title">
                <span className="quickk">{T("Quick Actions")}</span>
                <div className="moreicons-li">
                  {isAuthenticated ? (
                    <Link to="/OrgCentral" className="aimg">
                      <img src="/images/menu-icon/accountowner.svg" />
                      Manage Account {IsMenuloading}
                    </Link>
                  ) : (
                    ""
                  )}
                  {mySetting ? (
                    <Link to="/Preferences" className="aimg">
                      <img src="/images/org-img/task/setting.svg" /> My Settings
                    </Link>
                  ) : (
                    ""
                  )}
                  <a className="closebtn">×</a>
                </div>
              </div>
              <div className="tab-content close-tab">
                <div className="row p-2">
                  {MenueIconList?.EmployeeFunctionalityGroups?.length > 0 ? (
                    MenueIconList.EmployeeFunctionalityGroups.map(
                      (category, index) => (
                        <div className="col-md-12" key={index}>
                          <div className="linkcl">
                            <span className="morespan">
                              {category?.CategoryName}
                            </span>

                            <div className="navmenulis">
                              {category?.EmployeeFunctionalityList?.map(
                                (menu, i) => {
                                  const restrictedCodes = [
                                    "LV-005",
                                    "LV-006",
                                    "LV-007",
                                    "WH-003",
                                    "WH-005",
                                    "WH-006",
                                  ];
                                  if (
                                    userDetails?.DirectReporteeCount === 0 &&
                                    restrictedCodes.includes(menu?.Code)
                                  ) {
                                    return null;
                                  }
                                  return (
                                    <a key={i}>
                                      <div
                                        className="menuicons"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <img
                                          onClick={() =>
                                            redirectToAnotherPage(menu)
                                          }
                                          src={
                                            menu?.IconPath ||
                                            "/images/menu-icon/quick-action/others/02.png"
                                          }
                                          alt="menu icon"
                                        />
                                      </div>
                                      <span>{menu?.FeatureName}</span>
                                    </a>
                                  );
                                },
                              )}
                            </div>
                          </div>
                        </div>
                      ),
                    )
                  ) : (
                    <div className="text-center w-100 p-5">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">
                          {IsMenuloading ? (
                            <Suspense>
                              <ComponentLoader />
                            </Suspense>
                          ) : (
                            ""
                          )}
                        </span>
                      </div>
                    </div>
                  )}
                </div>

                {/* <div className="row p-2">
                  {MenueIconList?.EmployeeFunctionalityGroups?.map((category, index) =>
                  (<div className="col-md-12" key={index}>
                    <div className="linkcl">
                      <span className="morespan">{category?.CategoryName}</span>
                      <div className="navmenulis">
                        {category?.EmployeeFunctionalityList?.map((menu, I) =>
                          <a key={I}>
                            <div className="menuicons" style={{ cursor: 'pointer' }}>
                              <img onClick={() => redirectToAnotherPage(menu)} src={menu?.IconPath || "/images/menu-icon/quick-action/others/02.png"} /></div>
                            <span>{menu?.FeatureName}</span>
                          </a>
                        )}
                      </div>
                    </div>
                  </div>)
                  )}
                </div> */}
              </div>
            </div>
          </ul>
          <ul className="metismenu menu2" id="menu">
           
            {employeeRead && (
              <li>
                <a
                  className="has-arrow ai-icon"
                  onClick={openSearch}
                  aria-expanded="false"
                  data-bs-toggle="tooltip"
                  data-placement="right"
                  title="Search"
                >
                  <img src="/images/menu-icon/search.svg" />
                </a>
              </li>
            )}
            <li>
              {/* <div className="action-req"> */}
              <Link
                to="/Notification"
                className="has-arrow ai-icon notification"
                aria-expanded="false"
                data-bs-toggle="tooltip"
                data-placement="right"
                title="Notification"
              >
                <img src="/images/menu-icon/notifications.svg" />
                {notificationsList > 0 && (
                  <span className="badge">{notificationsList}</span>
                )}
              </Link>
              {/* </div> */}
            </li>
            <div
              id="searchmyNav"
              className="overlay position-relation"
              style={{ padding: "0px" }}
            >
              <Link to="/Dashboard" className="closebtn" onClick={closeSearch}>
                &times;
              </Link>
              {isVisibleAutocomplete && (
                <div id="appw-cover">
                  <div id="app">
                    <label className="search-label">
                      What would you like to search ?
                    </label>
                    <p className="search-paraa">Search Employee .</p>
                    <div>
                      <form>
                        <div id="f-element">
                          <div id="inp-cover">
                            <AutoComplete
                              field="FullName"
                              value={selectedObservers}
                              suggestions={filteredObservers}
                              completeMethod={fetchEmployeeIdData}
                              onChange={(e) => setSelectedObservers(e.value)}
                              onKeyDown={handleKeyDown}
                              itemTemplate={itemTemplateObservers}
                              panelFooterTemplate={panelFooterTemplate}
                              style={{ width: "100%" }}
                            />
                          </div>
                        </div>
                        <button
                          type="button"
                          className="shadow"
                          onClick={() => userDetailsPage()}
                        >
                          <i className="fa fa-search"></i>
                          <span className="search-loader">
                            {loader ? <LoginLoader /> : ""}
                          </span>
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <li className="mobileviewhide">
              <a className="image has-arrow ai-icon" aria-expanded="false">
                <img
                  className="logout-profile"
                  src={userDetails?.ProfileImage || defaultImage}
                  onError={handleImageError}
                  width="32"
                  style={{ opacity: "1", borderRadius: "9px" }}
                />
              </a>
              <ul aria-expanded="false" className="ullist-edit p-0">
                <Link to={`/Profile/${userDetails?.GUID}`}>
                  <li className="firtullist">
                    <img
                      src={userDetails?.ProfileImage || defaultImage}
                      className="lastpro-img"
                      onError={handleImageError}
                    />
                    <div>
                      <p>
                        <b>{userDetails?.FullName}</b>
                        {userDetails?.CurrentDesignation}
                      </p>
                    </div>
                  </li>
                </Link>
                <li className="nxtullist">
                  <Link
                    to={`/Profile/${userDetails?.GUID}`}
                    className="d-flex align-items-flex-start"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      fill="currentColor"
                      className="bi bi-person"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                    </svg>
                    <div>
                      <p>
                        <b>Profile</b>
                        <span>View your profile</span>
                      </p>
                    </div>
                  </Link>
                </li>
                {userDetails?.IsPasswordSet === true ? (
                  <>
                    <li className="nxtullist">
                      <Link
                        to="/ChangePassword"
                        className="d-flex align-items-flex-start"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          fill="currentColor"
                          className="bi bi-shield-lock"
                          viewBox="0 0 16 16"
                        >
                          <path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z" />
                          <path d="M9.5 6.5a1.5 1.5 0 0 1-1 1.415l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99a1.5 1.5 0 1 1 2-1.415z" />
                        </svg>
                        <div>
                          <p>
                            <b>Change password</b>
                            <span>Manage Your Password</span>
                          </p>
                        </div>
                      </Link>
                    </li>
                  </>
                ) : (
                  <>
                    <li className="nxtullist">
                      <Link
                        to="/SetPassword"
                        className="d-flex align-items-flex-start"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          fill="currentColor"
                          className="bi bi-shield-lock"
                          viewBox="0 0 16 16"
                        >
                          <path d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z" />
                          <path d="M9.5 6.5a1.5 1.5 0 0 1-1 1.415l.385 1.99a.5.5 0 0 1-.491.595h-.788a.5.5 0 0 1-.49-.595l.384-1.99a1.5 1.5 0 1 1 2-1.415z" />
                        </svg>
                        <div>
                          <p>
                            <b>Set password</b>
                            <span>Manage Your Password</span>
                          </p>
                        </div>
                      </Link>
                    </li>
                  </>
                )}
                <li className="nxtullist">
                  <Link
                    to="/SendUsFeedback"
                    className="d-flex align-items-flex-start"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      fill="currentColor"
                      className="bi bi-star"
                      viewBox="0 0 16 16"
                    >
                      <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z" />
                    </svg>

                    <div>
                      <p>
                        <b>Send Us Feedback</b>
                        <span>Share Your Experience</span>
                      </p>
                    </div>
                  </Link>
                </li>
                <li className="nxtullist">
                  <Link
                    to="/SuggestAfeature"
                    className="d-flex align-items-flex-start"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      fill="currentColor"
                      className="bi bi-chat-dots"
                      viewBox="0 0 16 16"
                    >
                      <path d="M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                      <path d="m2.165 15.803.02-.004c1.83-.363 2.948-.842 3.468-1.105A9 9 0 0 0 8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.4 10.4 0 0 1-.524 2.318l-.003.011a11 11 0 0 1-.244.637c-.079.186.074.394.273.362a22 22 0 0 0 .693-.125m.8-3.108a1 1 0 0 0-.287-.801C1.618 10.83 1 9.468 1 8c0-3.192 3.004-6 7-6s7 2.808 7 6-3.004 6-7 6a8 8 0 0 1-2.088-.272 1 1 0 0 0-.711.074c-.387.196-1.24.57-2.634.893a11 11 0 0 0 .398-2" />
                    </svg>
                    <div>
                      <p>
                        <b>Suggest a Feature</b>
                        <span>Improve With Us</span>
                      </p>
                    </div>
                  </Link>
                </li>
                {/* <li className="nxtullist">
                  <a href="/Legal" target="_blank" className="d-flex align-items-flex-start">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="22"
                      height="22"
                      fill="currentColor"
                      className="bi bi-file-text"
                      viewBox="0 0 16 16"
                    >
                      <path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5M5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z" />
                      <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1" />
                    </svg>
                    <div>
                      <p>
                        <b>Legal</b>
                        <span>Terms and Policies</span>
                      </p>
                    </div>
                  </a>
                </li> */}
                <p className="send-feedback mb-0">
                  <span className="d-block">{orgInfoMes}</span>
                  <span>
                    {poweredBy_Header}{" "}
                    <a href={orgPoweredUrl} target="_blank">
                      {orgPowered}
                    </a>
                  </span>
                  <span></span>
                </p>
                {orgPowered?.Url}

                <p className="send-feedback">
                  <Link to="/Version">
                    Version &nbsp;
                    {AppVersion?.NewVersion}
                    {/* // userDetails?.AppVersions?.find((el) => el?.Type == "Web")
                      //   ?.NewVersion
                    // } */}
                  </Link>
                </p>
                <li className="logout-li-tbn">
                  <a
                    className="lastbtnn"
                    data-toggle="tooltip"
                    data-placement="top"
                    data-bs-toggle="modal"
                    data-bs-target="#logout-popup"
                  >
                    {T("Log Out")}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      {/* <FeedPost /> */}
      <div className="modal fade" id="add-apps">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add App</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body">
              <label className="mt-3">App Title</label>
              <input
                type="text"
                name=""
                className="form-control"
                placeholder="Title of the App"
              />
              <label className="mt-3">Links</label>
              <input
                type="text"
                name=""
                className="form-control"
                placeholder="App URL"
              />
              <div className="applist">
                <span className="morespan">Existing App</span>
                <a>
                  <img src="/images/menu-icon/quick-action/apps/01.png" />
                  <i className="fa fa-close"></i>
                  <span>Apps 1</span>
                </a>
                <a>
                  <img src="/images/menu-icon/quick-action/apps/02.png" />
                  <i className="fa fa-close"></i>
                  <span>Apps 2</span>
                </a>
                <a>
                  <img src="/images/menu-icon/quick-action/apps/03.png" />
                  <i className="fa fa-close"></i>
                  <span>Apps 3</span>
                </a>
                <a>
                  <img src="/images/menu-icon/quick-action/apps/04.png" />
                  <i className="fa fa-close"></i>
                  <span>Apps 4</span>
                </a>
                <a>
                  <img src="/images/menu-icon/quick-action/apps/05.png" />
                  <i className="fa fa-close"></i>
                  <span>Apps 5</span>
                </a>
              </div>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="btn btn-danger light"
                data-bs-dismiss="modal"
              >
                Decline
              </button>
              <button type="button" className="btn btn-primary">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade " id="logout-popup">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-body text-center">
              <div className="img">
                <img src="/images/logout.svg" />
              </div>
              <strong className="modal-title">Logout</strong>
              {logoutContent && <p>{logoutContent}</p>}
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="logoutbtn-click"
                onClick={() => handleLogout()}
              >
                {Isloading ? <LoginLoader /> : ""} Logout
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="check-feedpost">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Create a Post</h5>
              <button
                onClick={() => ResetFeedFields()}
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body p-2">
              <div className="add-postpopup-modal">
                <div className="image">
                  <img
                    src={userDetails?.ProfileImage || defaultImage}
                    onError={handleImageError}
                    data-demo-src="/images/main-body/1.jpg"
                    data-user-popover="1"
                    alt=""
                  />
                </div>
                <div className="feed-div">
                  <div className="flex justify-content-center">
                    {/* <div className="info-tooltip-area2">
                      <img
                        src="/images/org-img/leave/info.svg"
                        className="infoimg"
                      />
                      <div className="info-tooltip-content info-area">
                        <div
                          className="purchase-tooltip-content"
                          style={{ whiteSpace: "pre-wrap" }}
                        >
                          {`1. Heading Text
Use the <h1>Text...</h1> tag.

2. Bold Text
Use the <b>Text...</b> or <strong> tag.

3. Italic Text
Use the <i>Text...</i> or <em> tag.

4. Center Text
Use the <center>Text...</center> tag.

5. New Paragraph
Use the <p>Text...</p> tag.`}
                        </div>
                      </div>
                    </div> */}
                    <Mention
                      onChange={(e) => {
                        const trimmedValue = e.target.value.trimStart(); // trims leading spaces only
                        setFeedText(trimmedValue);
                      }}
                      onBlur={(e) => {
                        setFeedText(e.target.value.trim()); // trims both ends when losing focus
                      }}
                      className={"w-100"}
                      value={feedText}
                      inputId="feedareatext"
                      onSelect={onSelectHandler}
                      onFocus={(e) => {
                        getFeedText(e);
                      }}
                      trigger={["@", "#"]}
                      suggestions={multipleSuggestions}
                      onSearch={onMultipleSearch}
                      field={["FullName"]}
                      placeholder="Enter @ to mention people, # to mention tag"
                      itemTemplate={multipleItemTemplate}
                      rows={8}
                      cols={100}
                      maxLength={2000}
                    />
                  </div>
                  <div
                    style={{
                      textAlign: "right",
                      fontSize: "12px",
                      position: "absolute",
                      right: "27px",
                      bottom: "1px",
                      color: feedText?.length >= 2000 ? "red" : "#555",
                    }}
                  >
                    {feedText?.length || 0}/2000
                  </div>
                  <div className="upload-emoji">
                    <span>Smileys </span>
                    <img
                      src="/images/org-img/close.png"
                      className="Hide-upload-div2"
                    />
                    <div>
                      <ul className="emoji-ul">
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-emoji-smile-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zM4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8z" />
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-emoji-heart-eyes-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zM4.756 4.566c.763-1.424 4.02-.12.952 3.434-4.496-1.596-2.35-4.298-.952-3.434zm6.559 5.448a.5.5 0 0 1 .548.736A4.498 4.498 0 0 1 7.965 13a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .548-.736h.005l.017.005.067.015.252.055c.215.046.515.108.857.169.693.124 1.522.242 2.152.242.63 0 1.46-.118 2.152-.242a26.58 26.58 0 0 0 1.109-.224l.067-.015.017-.004.005-.002zm-.07-5.448c1.397-.864 3.543 1.838-.953 3.434-3.067-3.554.19-4.858.952-3.434z" />
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-emoji-laughing-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5c0 .501-.164.396-.415.235C6.42 6.629 6.218 6.5 6 6.5c-.218 0-.42.13-.585.235C5.164 6.896 5 7 5 6.5 5 5.672 5.448 5 6 5s1 .672 1 1.5zm5.331 3a1 1 0 0 1 0 1A4.998 4.998 0 0 1 8 13a4.998 4.998 0 0 1-4.33-2.5A1 1 0 0 1 4.535 9h6.93a1 1 0 0 1 .866.5zm-1.746-2.765C10.42 6.629 10.218 6.5 10 6.5c-.218 0-.42.13-.585.235C9.164 6.896 9 7 9 6.5c0-.828.448-1.5 1-1.5s1 .672 1 1.5c0 .501-.164.396-.415.235z" />
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-emoji-expressionless-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM4.5 6h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm5 0h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm-5 4h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1z" />
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-emoji-smile-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zM4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8z" />
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-emoji-heart-eyes-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zM4.756 4.566c.763-1.424 4.02-.12.952 3.434-4.496-1.596-2.35-4.298-.952-3.434zm6.559 5.448a.5.5 0 0 1 .548.736A4.498 4.498 0 0 1 7.965 13a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .548-.736h.005l.017.005.067.015.252.055c.215.046.515.108.857.169.693.124 1.522.242 2.152.242.63 0 1.46-.118 2.152-.242a26.58 26.58 0 0 0 1.109-.224l.067-.015.017-.004.005-.002zm-.07-5.448c1.397-.864 3.543 1.838-.953 3.434-3.067-3.554.19-4.858.952-3.434z" />
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-emoji-laughing-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5c0 .501-.164.396-.415.235C6.42 6.629 6.218 6.5 6 6.5c-.218 0-.42.13-.585.235C5.164 6.896 5 7 5 6.5 5 5.672 5.448 5 6 5s1 .672 1 1.5zm5.331 3a1 1 0 0 1 0 1A4.998 4.998 0 0 1 8 13a4.998 4.998 0 0 1-4.33-2.5A1 1 0 0 1 4.535 9h6.93a1 1 0 0 1 .866.5zm-1.746-2.765C10.42 6.629 10.218 6.5 10 6.5c-.218 0-.42.13-.585.235C9.164 6.896 9 7 9 6.5c0-.828.448-1.5 1-1.5s1 .672 1 1.5c0 .501-.164.396-.415.235z" />
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-emoji-expressionless-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM4.5 6h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm5 0h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm-5 4h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1z" />
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-emoji-smile-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zM4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8z" />
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-emoji-heart-eyes-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zM4.756 4.566c.763-1.424 4.02-.12.952 3.434-4.496-1.596-2.35-4.298-.952-3.434zm6.559 5.448a.5.5 0 0 1 .548.736A4.498 4.498 0 0 1 7.965 13a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .548-.736h.005l.017.005.067.015.252.055c.215.046.515.108.857.169.693.124 1.522.242 2.152.242.63 0 1.46-.118 2.152-.242a26.58 26.58 0 0 0 1.109-.224l.067-.015.017-.004.005-.002zm-.07-5.448c1.397-.864 3.543 1.838-.953 3.434-3.067-3.554.19-4.858.952-3.434z" />
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-emoji-laughing-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5c0 .501-.164.396-.415.235C6.42 6.629 6.218 6.5 6 6.5c-.218 0-.42.13-.585.235C5.164 6.896 5 7 5 6.5 5 5.672 5.448 5 6 5s1 .672 1 1.5zm5.331 3a1 1 0 0 1 0 1A4.998 4.998 0 0 1 8 13a4.998 4.998 0 0 1-4.33-2.5A1 1 0 0 1 4.535 9h6.93a1 1 0 0 1 .866.5zm-1.746-2.765C10.42 6.629 10.218 6.5 10 6.5c-.218 0-.42.13-.585.235C9.164 6.896 9 7 9 6.5c0-.828.448-1.5 1-1.5s1 .672 1 1.5c0 .501-.164.396-.415.235z" />
                          </svg>
                        </li>
                        <li>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="bi bi-emoji-expressionless-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM4.5 6h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm5 0h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm-5 4h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1z" />
                          </svg>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-9">
                <div className="fs-13 text-danger">{fileSizeError}</div>
              </div>
              {Isloading ? (
                <Skeleton height={270} width="100%" />
              ) : (
                <div>
                  <div className="upload-img">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-x-square-fill Hide-upload-div"
                      onClick={() => hidePopup()}
                      viewBox="0 0 16 16"
                    >
                      <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm3.354 4.646L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708" />
                    </svg>
                    <img
                      src="/images/org-img/upload.png"
                      alt="upload"
                      className="w-100"
                      onDrop={handleDrop}
                      onDragOver={handleDragOver}
                      onClick={openSelectImageInput}
                    />
                  </div>
                  {showCropper && (
                    <ImageCropperModalMulti
                      image={imageSrc}
                      images={multiImageSrcs}
                      acceptRatio={acceptRatio}
                      onComplete={handleCropComplete}
                      onClose={() => setShowCropper(false)}
                    />
                  )}

                  <div className="input-Btn add-more-pictures">
                    <p>Add More</p>
                    <input
                      className="input-Btn"
                      name="file"
                      type="file"
                      accept="image/*,video/mp4"
                      onChange={handleFileImageChange}
                      id="fileInput"
                      ref={fileImageInputRef}
                      multiple
                      onClick={openFileInput}
                      onDrop={handleDrop}
                      onDragOver={handleDragOver}
                      style={{ opacity: "0" }}
                    />
                  </div>
                </div>
              )}
              {ImagePath && ImagePath.length !== 0 ? (
                <div className="upload-imgCarousel">
                  <Carousel
                    value={ImagePath}
                    numVisible={3}
                    numScroll={3}
                    className="custom-carousel"
                    responsiveOptions={responsiveOptions}
                    circular
                    autoplayInterval={3000}
                    itemTemplate={(media) =>
                      UploadedMediaTemplate(media, ImagePath.indexOf(media))
                    }
                  />
                </div>
              ) : (
                ""
              )}
              <div className="actions">
                <ul className="d-flex p-0 m-0">
                  <li className="Show-upload-div" onClick={showPopup}>
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 16 16"
                      className="text-success pe-2"
                      height="20"
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M.002 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2zm1 9v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062zm5-6.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0"></path>
                    </svg>
                    Photos / Videos
                  </li>
                  <li
                    className="Show-upload-div "
                    onClick={() => setisVisibleEmoji(!isVisibleEmoji)}
                  >
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 16 16"
                      className="text-warning pe-2"
                      height="20"
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5M4.285 9.567a.5.5 0 0 1 .683.183A3.5 3.5 0 0 0 8 11.5a3.5 3.5 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683M10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8"></path>
                    </svg>
                    Feelings/activity
                  </li>
                </ul>
                {isVisibleEmoji && <EmojiPicker onEmojiClick={onEmojiClick} />}
              </div>
            </div>
            <div className="modal-footer footer-feed">
              <button
                type="submit"
                disabled={!isVisible}
                onClick={PostFeed}
                className="btn"
              >
                {T("Post")}
              </button>
            </div>
          </div>
        </div>
        {Isloading ? (
          <Suspense>
            <ComponentLoader />
          </Suspense>
        ) : (
          ""
        )}
      </div>
      {isOnline ? (
        ""
      ) : (
        <div className="nointernetpopup">
          <div className="nointernetcontent">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-wifi-off"
              viewBox="0 0 16 16"
            >
              <path d="M10.706 3.294A12.6 12.6 0 0 0 8 3C5.259 3 2.723 3.882.663 5.379a.485.485 0 0 0-.048.736.52.52 0 0 0 .668.05A11.45 11.45 0 0 1 8 4q.946 0 1.852.148zM8 6c-1.905 0-3.68.56-5.166 1.526a.48.48 0 0 0-.063.745.525.525 0 0 0 .652.065 8.45 8.45 0 0 1 3.51-1.27zm2.596 1.404.785-.785q.947.362 1.785.907a.482.482 0 0 1 .063.745.525.525 0 0 1-.652.065 8.5 8.5 0 0 0-1.98-.932zM8 10l.933-.933a6.5 6.5 0 0 1 2.013.637c.285.145.326.524.1.75l-.015.015a.53.53 0 0 1-.611.09A5.5 5.5 0 0 0 8 10m4.905-4.905.747-.747q.886.451 1.685 1.03a.485.485 0 0 1 .047.737.52.52 0 0 1-.668.05 11.5 11.5 0 0 0-1.811-1.07M9.02 11.78c.238.14.236.464.04.66l-.707.706a.5.5 0 0 1-.707 0l-.707-.707c-.195-.195-.197-.518.04-.66A2 2 0 0 1 8 11.5c.374 0 .723.102 1.021.28zm4.355-9.905a.53.53 0 0 1 .75.75l-10.75 10.75a.53.53 0 0 1-.75-.75z" />
            </svg>
            <h3>No internet Connection</h3>
            <p>
              You are Offline
              <br />
              {orggenie_Error_Network}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default SharedSidebar;
